var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_vm._v(" Bild ")]),_c('v-flex',[_c('register-form')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }